import { render, staticRenderFns } from "./SidebarThree.vue?vue&type=template&id=6682376e&scoped=true&"
import script from "./SidebarThree.vue?vue&type=script&lang=js&"
export * from "./SidebarThree.vue?vue&type=script&lang=js&"
import style0 from "./SidebarThree.vue?vue&type=style&index=0&id=6682376e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6682376e",
  null
  
)

export default component.exports